import { useRef } from 'react';
import { v4 as uuid } from 'uuid';

export const useUuid = (): string => {
  const uuidRef = useRef('');
  if (!uuidRef.current) {
    uuidRef.current = uuid();
  }

  return uuidRef.current;
};
